import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Mobile, Landscape } from "../Response";
const Experience = () => {
  const back = useSelector((state) => state.switch.back);
  return (
    <Container>
      <Wrap back={back}>
        <ExperCon back={back}>
          <Title back={back}>MERN STACK EXPERT </Title>
          <IconsCon>
            <EachIcon>
              <IconImg src="https://cdn.iconscout.com/icon/free/png-256/mongodb-4-1175139.png" />
              <TextIcon className="lan">MongoDb</TextIcon>
            </EachIcon>
            <EachIcon>
              <IconImg
                ex="ex"
                src="https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png"
              />
              <TextIcon>Express.js</TextIcon>
            </EachIcon>
            <EachIcon>
              <IconImg
                re="re"
                src="https://brandlogos.net/wp-content/uploads/2020/09/react-logo-512x512.png"
              />
              <TextIcon>React.js</TextIcon>
            </EachIcon>
            <EachIcon>
              <IconImg
                no="no"
                src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png"
              />
              <TextIcon>Node.js</TextIcon>
            </EachIcon>
          </IconsCon>
        </ExperCon>
        <SkillCon back={back}>
          <SkillText back={back}>Skills </SkillText>
          <SkillIcons>
            <IconsE
              sm="sm"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Unofficial_JavaScript_logo_2.svg/2048px-Unofficial_JavaScript_logo_2.svg.png"
            />
            <IconsE
              sm="sm"
              src="https://cdn.worldvectorlogo.com/logos/html-1.svg"
            />
            <IconsE
              sm="sm"
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png"
            />
            <IconsE src="https://cdn.iconscout.com/icon/free/png-256/mongodb-4-1175139.png" />
            <IconsE src="https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png" />
            <IconsE src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png" />
            <IconsE src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" />
            <IconsE src="https://seeklogo.com/images/R/redux-logo-9CA6836C12-seeklogo.com.png" />
            <IconsE src="https://assets.stickpng.com/images/58480979cef1014c0b5e4901.png" />
            <IconsE src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Sass_Logo_Color.svg/1280px-Sass_Logo_Color.svg.png" />
            <IconsE
              sm="sm"
              src="https://play-lh.googleusercontent.com/2PS6w7uBztfuMys5fgodNkTwTOE6bLVB2cJYbu5GHlARAK36FzO5bUfMDP9cEJk__cE"
            />
            <IconsE src="https://cdn.icon-icons.com/icons2/2415/PNG/512/csharp_original_logo_icon_146578.png" />
            <IconsE src="https://avatars.githubusercontent.com/u/7552965?s=280&v=4" />
            <IconsE src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1869px-Python-logo-notext.svg.png" />
            <IconsE src="https://miro.medium.com/max/318/1*7jRD5QhgARucFKvRHFxpOg.png" />
            <IconsE src="https://www.pngrepo.com/download/303670/firebase-1-logo.png" />
            <IconsE src="https://seeklogo.com/images/M/material-ui-logo-5BDCB9BA8F-seeklogo.com.png" />
            <IconsE src="https://brandlogos.net/wp-content/uploads/2021/09/bootstrap-logo.png" />
            <IconsE src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" />
            <IconsE src="https://cdn-icons-png.flaticon.com/512/25/25231.png" />
            <IconsE
              sm="sm"
              src="https://seeklogo.com/images/P/photoshop-2020-logo-37B02055A4-seeklogo.com.png"
            />
            <IconsE
              sms="sm"
              src="https://assets.stickpng.com/images/62c5bf6f6aad5aedf80e3801.png"
            />
            <IconsE src="https://miro.medium.com/max/1400/1*x33n87v9KyFflJ5qD2HabQ.png" />
            {/* <Icons src="" /> */}
          </SkillIcons>
        </SkillCon>
      </Wrap>
    </Container>
  );
};
export default Experience;
const Container = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100vh;
  margin: 100px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Mobile({ margin: "80px 0px", height: "75vh" })}
  ${Landscape({ margin: "50px 0px", height: "110vh" })}
`;
const Wrap = styled.div`
  border-radius: 20px;

  background: ${(props) =>
    props.back === "sun" ? "rgb(252, 254, 255)" : "rgba(26, 32, 39,0.2)"};
  // background: rgba(143, 166, 168, 0.22);
  padding: 30px;
  width: 56%;
  height: 70%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 3px solid rgba(143, 166, 168, 0.1);
  gap: 50px;
  ${Mobile({
    width: "97%",
    height: "95%",
    borderRadius: 10,
    padding: 5,
    gap: 20,
    border: "1px solid rgba(143, 166, 168, 0.1)",
  })}
  ${Landscape({ width: "65%", height: " 95%", gap: 20, padding: 20 })}
`;
const ExperCon = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  background: ${(props) =>
    props.back === "sun" ? " rgb(255, 255, 255)" : "rgba(26, 32, 39,1)"};
  box-shadow: ${(props) =>
    props.back === "sun" && "0px 5px 9px 0px rgba(143, 166, 168, 0.25)"};
  ${Mobile({
    borderRadius: 10,
    // boxShadow: "0px 5px 9px 0px rgba(143, 166, 168, 0.15)",
    border: "1px solid rgba(143, 166, 168, 0.25)",
  })}
  ${Landscape({ flex: 1, padding: "10px 10px", borderRadius: 10 })}
`;
const Title = styled.h4`
  font-size: 22px;
  gap: 20px;
  color: ${(props) =>
    props.back === "sun" ? " #7d7d7d" : " rgba(228, 236, 240, 0.9)"};
  flex: 1;
  font-weight: 700;
  ${Mobile({ fontSize: 18 })}
  ${Landscape({ gap: 0, fontSize: 18 })}
`;
const IconsCon = styled.div`
  // background: green;
  flex: 2;
  width: 60%;
  padding: 10px 30px 5px 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  ${Mobile({ width: "95%" })};
  ${Landscape({ width: "80%" })};
`;
const EachIcon = styled.div`
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;
const IconImg = styled.img`
  width: 50%;
  height: 50%;

  width: ${(props) => props.no === "no" && 36}%;
  height: ${(props) => props.no === "no" && 43}%;
  margin: ${(props) => props.ex && props.no && 7}px 0px;

  width: ${(props) => props.ex && 38}%;
  height: ${(props) => props.ex && 40}%;
  height: ${(props) => props.re && 50}%;
  width: ${(props) => props.re === "re" && 42}%;
  justify-self: flex-end;
  ${Landscape({ width: "30%", height: "45%" })}
`;
const TextIcon = styled.h6`
  color: #929292;
  font-size: 17px;
  font-weight: 400;
  text-align: center;
  ${Mobile({ fontSize: 12 })}
`;

const SkillCon = styled.div`
  flex: 3.5;

  background: ${(props) =>
    props.back === "sun" ? " #f9fdff" : "rgba(26, 32, 39,0.3)"};
  width: 100%;
  padding: 20px;
  border: 2px solid rgba(143, 166, 168, 0.1);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  // background: red;
  ${Mobile({ gap: 10 })}
  ${Landscape({ gap: 5, flex: 2.5, padding: "10px" })}
`;
const SkillText = styled.h5`
  color: ${(props) =>
    props.back === "sun" ? " #7d7d7d" : " rgba(228, 236, 240, 0.8)"};
  font-size: 22px;
  ${Mobile({ fontSize: 20 })}
  // flex: 1;
  font-weight: 500;
  ${Landscape({ fontSize: 20 })}
`;
const SkillIcons = styled.div`
  // background: red;
  // width:80%;
  padding: 0px 60px;
  display: flex;
  justify-content: CENTER;
  align-items: center;
  gap: 25px;
  flex-wrap: wrap;
  ${Mobile({ padding: "5px 10px" })}
  ${Landscape({ padding: "10px 10px", gap: 15 })}
`;
const IconsE = styled.img`
  width: 35px;
  width: ${(props) => props.sm && 32}px;
  width: ${(props) => props.sms && 31}px;
  height: auto;
  // opacity:0.7;
  ${Mobile({ width: 25 })}
  ${(props) => props.sm && Mobile({ width: "20px" })};
  ${Landscape({ width: "6%" })}
`;
